/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValuePerBinderDetailResponseDto } from './ValuePerBinderDetailResponseDto';
import {
    ValuePerBinderDetailResponseDtoFromJSON,
    ValuePerBinderDetailResponseDtoFromJSONTyped,
    ValuePerBinderDetailResponseDtoToJSON,
    ValuePerBinderDetailResponseDtoToJSONTyped,
} from './ValuePerBinderDetailResponseDto';

/**
 * 
 * @export
 * @interface ValuePerBinderResponseDto
 */
export interface ValuePerBinderResponseDto {
    /**
     * 
     * @type {ValuePerBinderDetailResponseDto}
     * @memberof ValuePerBinderResponseDto
     */
    shareOfLimitQuoted: ValuePerBinderDetailResponseDto;
    /**
     * 
     * @type {ValuePerBinderDetailResponseDto}
     * @memberof ValuePerBinderResponseDto
     */
    shareOfPremiumQuoted: ValuePerBinderDetailResponseDto;
}

/**
 * Check if a given object implements the ValuePerBinderResponseDto interface.
 */
export function instanceOfValuePerBinderResponseDto(value: object): value is ValuePerBinderResponseDto {
    if (!('shareOfLimitQuoted' in value) || value['shareOfLimitQuoted'] === undefined) return false;
    if (!('shareOfPremiumQuoted' in value) || value['shareOfPremiumQuoted'] === undefined) return false;
    return true;
}

export function ValuePerBinderResponseDtoFromJSON(json: any): ValuePerBinderResponseDto {
    return ValuePerBinderResponseDtoFromJSONTyped(json, false);
}

export function ValuePerBinderResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValuePerBinderResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'shareOfLimitQuoted': ValuePerBinderDetailResponseDtoFromJSON(json['shareOfLimitQuoted']),
        'shareOfPremiumQuoted': ValuePerBinderDetailResponseDtoFromJSON(json['shareOfPremiumQuoted']),
    };
}

export function ValuePerBinderResponseDtoToJSON(json: any): ValuePerBinderResponseDto {
    return ValuePerBinderResponseDtoToJSONTyped(json, false);
}

export function ValuePerBinderResponseDtoToJSONTyped(value?: ValuePerBinderResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shareOfLimitQuoted': ValuePerBinderDetailResponseDtoToJSON(value['shareOfLimitQuoted']),
        'shareOfPremiumQuoted': ValuePerBinderDetailResponseDtoToJSON(value['shareOfPremiumQuoted']),
    };
}

